import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import { Turbo } from '@hotwired/turbo-rails'

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = ['content']

  connect() {
    this.modal = new Modal(this.element, {
      backdrop: 'static',
      keyboard: true,
      focus: true,
    })
    this.boundBeforeFetchResponse = this.beforeFetchResponse.bind(this)
    document.addEventListener('turbo:before-fetch-response', this.boundBeforeFetchResponse)
    this.show()
  }

  disconnect() {
    document.removeEventListener('turbo:before-fetch-response', this.boundBeforeFetchResponse)
    if (this.modal) {
      // A turbo_stream that replaces the #modal frame removes this element
      // without ever calling hide(), and dispose() leaves the body class
      // behind (hiding .multi-select-bar until the next full page load).
      document.body.classList.remove('modal-open')
      document.body.style.removeProperty('overflow')
      document.body.style.removeProperty('padding-right')
      this.modal.dispose()
    }
  }

  show() {
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }

  // Intercept successful responses before Turbo processes them
  beforeFetchResponse(event) {
    const response = event.detail.fetchResponse.response

    // Only handle successful responses (redirects result in 200 after following)
    if (response.ok && response.redirected) {
      const formElement = event.target?.closest('form')
      const shouldClose = formElement?.dataset?.turboModalClose !== 'false'

      if (shouldClose) {
        // Prevent Turbo from trying to find the frame
        event.preventDefault()
        // Navigate to the redirect URL
        Turbo.visit(response.url)
      }
    }
  }

  // Handle non-redirect successful submissions (if any)
  submitEnd(event) {
    if (event.detail.success) {
      const fetchResponse = event.detail.fetchResponse
      // Only handle if not already handled by beforeFetchResponse
      if (!fetchResponse?.response?.redirected) {
        const formElement = event.detail.formSubmission?.formElement
        const shouldClose = formElement?.dataset?.turboModalClose !== 'false'
        if (shouldClose) {
          this.hide()
        }
      }
    }
  }

  // Clean up when modal is hidden
  cleanup() {
    // Remove the turbo frame content when modal is completely hidden
    const turboFrame = document.getElementById('modal')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }
}
